import { IsNotEmpty, IsString, MinLength, MaxLength, Matches } from "class-validator";

export class AuthResetVerifyDTO {

    @IsNotEmpty()
    @IsString()
    @MinLength(20)
    @MaxLength(20)
    code: string;

}
